export default "__VITE_ASSET__DN350NJB__"